<section id="online-check-section" class="section-card-content">
  <form [formGroup]="onlineCheckForm">
    <p class="details tw-text-[15px] tw-text-[#0F2950]">
      {{ 'account.funding.iprecorded' | translate: 'Your IP Address and location will be recorded for fraud prevention purposes.' }}
    </p>

    <div class="deposit-details tw-mt-[10px] tw-mb-[15px]">
      <div class="row">
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#0F2950]">
            {{ 'account.funding.deposit.available' | translate: 'Funds Available' }}
          </span>
        </div>
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#0F2950]">{{ 'account.funding.withdraw.ach.time' | translate: '1-3 business days' }} </span>
        </div>
      </div>

      <div class="row">
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#0F2950]">{{ 'account.funding.fees' | translate: 'Fees' }}</span>
        </div>
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#0F2950]">{{ 'generic.password.strength.none' | translate: 'None' }}</span>
        </div>
      </div>

      <div class="row">
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#0F2950]">
            {{ 'account.funding.withdraw.maxwithdraw' | translate: 'Maximum Withdrawal' }}
          </span>
        </div>
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#0F2950]">
            ${{ ((balance > 1000) ? 1000 : balance) | number:'1.2' }}
          </span>
        </div>
      </div>

      <div class="row note">
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#0F2950]">
            {{ 'generic.note' | translate: 'Note:' }}
          </span>
        </div>
        <div class="column">
          <span class="tw-text-[15px] tw-text-[#0F2950]">
            {{ 'ui.funding.pending.deposits.may.lower.available.balance' | translate: 'Pending deposits may lower available balance.' }}
          </span>
        </div>
      </div>
    </div>

    <div class="deposit-details choose-account-list tw-mt-[32px] tw-mb-[35px]">
      <span class="tw-text-[16px]">{{ 'account.funding.account.choose' | translate: 'Choose Account' }}</span>
      <div class="account-list">
        <div
          *ngFor="let account of accounts$ | async; let i = index"
          (click)="chooseAccount('account-'+i, account?.AccountId)"
          class="row tw-mt-[5px]"
        >
          <div class="column">
            <span id="account-{{i}}" class="selector tw-flex"></span>
          </div>
          <div class="column tw-border-[#6298E2] tw-border-t-[1px] tw-pl-[7px]">
            <span class="tw-text-[16px] tw-text-[#0F2950]">
              {{ account?.AchName }} - {{account.AchAccount.toString() | slice:-4 }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="amount-row tw-relative">
      <!-- Message section -->
      <!-- tw-top-[-18px] -->
      <span class="tw-absolute tw-bottom-[-19px] tw-right-[0px] tw-h-[18px] tw-block tw-pt-[2px]">

        <!-- Required -->
        <span
          class="tw-block tw-text-right tw-text-xs tw-text-[#D83A19]"
          *ngIf="formVal['amount'] && formVal['amount']?.errors
            && (formVal['amount'].touched || formVal['amount'].dirty)"
        >
          {{
            'ui.funding.enter.valid.amount' | translate: 'Please enter valid amount.'
          }}
        </span>
      </span>

      <span class="amount-deposit-usd tw-block tw-text-[16px] tw-text-[#5D5D5D]">
        {{ 'account.funding.withdraw.amountto' | translate: 'Amount to be Withdrawn' }}
      </span>
      <input
        formControlName="amount"
        id="depositAmount"
        (keyup)="withdrawAmount()"
        type="number"
        class="amount tw-h-[38px] tw-text-[22px] tw-text-[#645858]"
        placeholder=""
        pattern="^\d+(\.\d{1,2})?$"
        amwager3DecimalInput
      />
    </div>

    <p class="notice1 tw-text-[14px] tw-text-[#0F2950] tw-mt-[30px] tw-mb-[22px]">
      {{ 'account.funding.withdraw.ach.inform' | translate }}
    </p>

    <div class="tw-flex tw-mt-[15px]">
      <mat-checkbox
        [checked]="isAgree"
        (change)="toggleCheckbox()"
        id="isAgree"
        class="tw-top-1 tw-mr-2 tw-mt-0 tw-mb-0"
      >
      </mat-checkbox>
      <p (click)="toggleCheckbox()" class="isAgree tw-self-center tw-font-bold tw-text-[15px] tw-text-[#0F2950] tw-mt-[8px]">
        {{ 'account.funding.withdraw.check.agree' | translate: 'I Agree to the Above Terms and Confirm the shown information is correct.' }}
      </p>
    </div>

    <button
      (click)="withdraw()"
      [ngClass]="{'active': (isAgree && accountId && !isProcessing && formVal['amount'].valid)}"
      [disabled]="!isAgree || !accountId || isProcessing || formVal['amount'].invalid"
      class="deposit-now tw-w-full tw-h-[41px] tw-text-[16px] tw-mt-[30px] tw-mb-[10px]"
    >
      {{ 'account.funding.withdraw.credit.btn.withdraw' | translate: 'Withdraw Now' }}
    </button>

  </form>
</section>
